import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { signOut } from '@aws-amplify/auth';

const NavBar = () => {
  const handleLogout = async () => {
    try {
      await signOut();
      // Optionally, redirect or refresh the page after logout:
      window.location.reload();
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#1E1E1E' }}>
      <Toolbar>
        <Typography variant="h6" sx={{ color: '#fff' }}>
          SES Email Manager
        </Typography>
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <Button sx={{ color: '#fff' }} component={Link} to="/">
            Dashboard
          </Button>
          <Button sx={{ color: '#fff' }} component={Link} to="/template-editor">
            Create Template
          </Button>
          <Button sx={{ color: '#fff' }} component={Link} to="/analytics">
            Analytics
          </Button>
          <Button sx={{ color: '#fff' }} component={Link} to="/settings">
            Settings
          </Button>
          <Button sx={{ color: '#fff' }} component={Link} to="/branding">
            Branding
          </Button>
        </Box>
        <Button sx={{ color: '#fff' }} onClick={handleLogout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
